import React from "react";
import Footer from "../layouts/Footer";
import biz from "../assets/img/turbo75.jpg";
import MenuBar from "../layouts/MenuBar";
import { Link } from "react-router-dom";

function Pricing() {
  return (
    <>
      <MenuBar />
      <div className="col-md-8 col-12 m-auto mt-4 pt-5 ">
        <img class="img-fluid" src={biz} alt="" className="biz" />
        <h1 className="mt-4">Hybrid Internet</h1>
        <p className="fast">
          We offer different UNLIMITED plans with no data cap, no usage
          threshold and no limited number of devices that can be connected.
          Select your preffered plan.
        </p>
        <div class="flex-parent-element">
          <div class="flex-child-element">
            <p class="f-p">Tizeti Turbo Connect</p>

            <p class="texts">
              N75,000 <small>/month</small>
            </p>

            <p class="fast">
              Fast and reliable internet for everyday use. Stream, browse and
              connect on our Tizeti Turbo Connect plan.
            </p>
            <ul className="pb-2 ul">
              <li>
                <i class="fa fa-check-square green-color"> Unlimited Data </i>
              </li>
              <li>
                <i class="fa fa-check-square green-color">
                  {" "}
                  P2P Dedicated link
                </i>
              </li>
              <li>
                <i class="fa fa-check-square green-color">
                  {" "}
                  Maximum Data, Stable Connection
                </i>
              </li>
              <li>
                <i class="fa fa-check-square green-color"> Up to 150Mbps</i>
              </li>
            </ul>
            <div className="click buttoned">
              <Link
                className="align"
                to={{
                  pathname: "/signup",
                  state: {
                    plan: "Tizeti Turbo Connect",
                    amount: "75000",
                    planName: "turbo_connect",
                  },
                }}
              >
                Sign up
              </Link>
            </div>
          </div>
          <div class="flex-child-element">
            {" "}
            <p class="f-p">Tizeti Turbo Connect Pro</p>
            <span>
              <p class="texts">
                N100,000 <small>/month</small>
              </p>
            </span>
            <p class="fast">
              Powerful internet for heavy usage. Experience top-notch speed and
              unlimited possibilities with our Tizeti Turbo Connect Pro package.
            </p>
            <ul className="pb-2 ul">
              <li>
                <i class="fa fa-check-square green-color"> Unlimited Data</i>
              </li>
              <li>
                <i class="fa fa-check-square green-color">
                  {" "}
                  P2P Dedicated link
                </i>
              </li>
              <li>
                <i class="fa fa-check-square green-color">
                  {" "}
                  Maximum Data, Stable Connection
                </i>
              </li>
              <li>
                <i class="fa fa-check-square green-color"> Up to 200Mbps</i>
              </li>
            </ul>{" "}
            <div className="click buttoned ">
              <Link
                className="align"
                to={{
                  pathname: "/signup",
                  state: {
                    plan: "Tizeti Turbo Connect Pro",
                    amount: "100000",
                    planName: "turbo_connect_pro",
                  },
                }}
              >
                Sign up
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <main> */}
      {/* <div class="banner">
          <img src={biz} alt="" class="biz" />
        </div>
        <div class="text">
          <h1 className="mt-4">Hybrid Internet</h1>

          <p className="fast">
            We offer different UNLIMITED plan with no data cap, no usage
            threshold and no limited on number of devices that can be connected.
            Select your preffered plan.
          </p>
        </div> */}
      {/*        
      </main> */}
      <Footer />
    </>
  );
}

export default Pricing;
